const handleDeleteEquipment = {
  confirm1: 'Do you really want to delete the equipment',
  confirm2: 'All Services and Actions related to this equipment will be deleted.',
  confirm3: 'Do you really want to delete these equipments?',
  title: 'DELETE EQUIPMENT',
  title2: 'DELETE EQUIPMENTS',
};

export default handleDeleteEquipment;
